import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PushArticlesBlogB2c } from '@components/push-articles-blog-b2c/models';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-push-articles-blog-b2c',
  imports: [OptionCardComponent, SvgComponent, RouterLink, TitleComponent],
  templateUrl: './push-articles-blog-b2c.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PushArticlesBlogB2cComponent extends AbstractDynamicComponent<PushArticlesBlogB2c> {}
